import { HelloARTracker } from "hello-mono-sdk/packages/utilities";

class Tracker {
  private static tracker?: HelloARTracker;

  static initTracker = (server: "PROD" | "DEV", sessionId?: string) => {
    if (!Tracker.tracker) {
      Tracker.tracker = new HelloARTracker({
        server: server,
        sessionId: sessionId,
      });
    }
  };
  static getTracker = () => {
    return Tracker.tracker;
  };
}

export default Tracker;
